import React from 'react'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useModal from '../../../hooks/useModal';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import { Container, Row, Col, ModalFooter } from 'react-bootstrap';
import Button from '../../../components/Button';
import Card from 'react-bootstrap/Card';

export type customOpenEnrollmentDecisionToolsProps = {
  showDecisionTools: boolean;
  handleCloseDecisionTools: () => void;
  handleShowExternalSiteWarning: () => void;
};



const OpenEnrollmentDecisionTools = ({
    showDecisionTools,
    handleCloseDecisionTools,
    handleShowExternalSiteWarning
  }: customOpenEnrollmentDecisionToolsProps) => {


    const handleCardClick = () => {
      handleCloseDecisionTools(); // Close the DecisionTools modal first
      handleShowExternalSiteWarning(); // Then show the warning modal
    };

  return (
    <Modal
      show={showDecisionTools}
      onHide={handleCloseDecisionTools}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Decision Tools</h4>
      </ModalHeader>
      <ModalBody>
        <Container className={'p-0 col-12 pb-10'}>
          <Row>
            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
              <Card className="card promoAd h-100" onMouseDown={handleCardClick}>
                <Card.Img
                  variant="top"
                  src={`${process.env.PUBLIC_URL}/${'adSneakPeek.png'}`}
                />
                <Card.Body>
                  <Card.Title>OE Sneak Peek</Card.Title>
                  <Card.Text>Your OE Highlights.</Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
              <Card className="card promoAd h-100" onMouseDown={handleCardClick}>
                <Card.Img
                  variant="top"
                  src={`${process.env.PUBLIC_URL}/${'adAlex-DLT.png'}`}
                />
                <Card.Body>
                  <Card.Title>Let alex Help</Card.Title>
                  <Card.Text>Compare your options</Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
              <Card className="card promoAd h-100" onMouseDown={handleCardClick}>
                <Card.Img
                  variant="top"
                  src={`${process.env.PUBLIC_URL}/${'adMBM.png'}`}
                />
                <Card.Body>
                  <Card.Title>MyBenefits Mentor</Card.Title>
                  <Card.Text>
                    Personalized recommendations driven by your claims
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
              <Card className="card promoAd h-100" onMouseDown={handleCardClick}>
                <Card.Img
                  variant="top"
                  src={`${process.env.PUBLIC_URL}/${'adPeopleLikeMe.png'}`}
                />
                <Card.Body>
                  <Card.Title>People Like Me</Card.Title>
                  <Card.Text>Examples to help you choose</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onClick={handleCloseDecisionTools}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
export default OpenEnrollmentDecisionTools